export const constants = {
    APP_PARAM_CATEGORY: 'APP',
    EDI: 'EDI',
    EDI_REGION_TWO: 'EDIR2',
    SUPPLIER_CONTACTS: 'CONTACT',
    COLLAB: 'SC',
    SGA: 'SGA',
    COLLABORATION: 'COLLABORATION',
    FORM_SELECTION: {
        ediFormOption: 1,
        supplierFormOption: 2,
        genericFormOption: 3,
        ediRegionTwoFormOption: 4,
        collabFormOption: 5,
        supplierGrouping: 6
    },
    ERROR_MESSAGES: {
        userId: {
            fieldKey: 'userId',
            message: 'Caller ID is required'
        },
        userName: {
            fieldKey: 'userName',
            message: 'User Name is required'
        },
        jobTitle: {
            fieldKey: 'jobTitle',
            message: 'The Job Title is required'
        },
        email: {
            fieldKey: 'email',
            message: 'Email is required'
        },
        comments: {
            fieldKey: 'comments',
            message: 'Comments are required'
        },
        impactedUserLastName: {
            fieldKey: 'impactedUserLastName',
            message: 'Impacted Last Name is required'
        },
        impactedUserFirstName: {
            fieldKey: 'impactedUserFirstName',
            message: 'Impacted User First Name is required'
        },
        impactedUserJobTitle: {
            fieldKey: 'impactedUserJobTitle',
            message: 'Impacted User Job Title is required'
        },
        impactedUserEmail: {
            fieldKey: 'impactedUserEmail',
            message: 'Impacted User Email is required'
        },
        impactedSupplierNumber: {
            fieldKey: 'impactedSupplierNumber',
            message: 'Impacted Supplier Number is required'
        },
        impactedSupplierName: {
            fieldKey: 'impactedSupplierName',
            message: 'Impacted Supplier Name is required'
        },
        impactedUserMiddleInit: {
            fieldKey: 'impactedUserMiddleInit',
            message: 'Impacted User Middle Init is required'
        },
        jdsnAppSelection: {
            fieldKey: 'jdsnAppSelection',
            message: 'JDSN Tool or Application option is required'
        },
        ediR2PartNumber: {
            fieldKey: 'ediR2PartNumber',
            message: 'Part Number option is required'
        },
        ediR2PurchaseOrder: {
            fieldKey: 'ediR2PurchaseOrder',
            message: 'Purchase Order option is required'
        },
        ediR2PlantCode: {
            fieldKey: 'ediR2PlantCode',
            message: 'Plant Code option is required'
        },
        ediR2SupplierNumber: {
            fieldKey: 'ediR2SupplierNumber',
            message: 'Supplier Number option is required'
        },
        ediR2Document: {
            fieldKey: 'ediR2Document',
            message: 'EDI Document option is required'
        },
        customOption: {
            fieldKey: 'customOption',
            message: 'A selection is required'
        }
    },
    ALERT_VARIANT: {
        success: {
            title: 'Service Now Incident was created',
            variant: 'success'
        },
        error: {
            title: 'Something went wrong',
            variant: 'error'
        }
    },
    URL_PARAMS: {
        APPID: 'APPID',
        USERID: 'USERID',
        TOOL: 'TOOL',
        COMMENTS: 'COMMENTS'
    },
    USER_NOT_FOUND: {
        FROM_API_MESSAGE: 'User Information Service: Not Found',
        ERROR_MESSAGE: 'Error Caller ID was not found, Please provide  a valid Caller ID.'
    },
    DROP_ZONE_ERROR_CODES: {
        size: 'file-too-large'
    },
    COLLAB_OPTIONS: {
        partPlan: 'PART_PLAN_SEARCH',
        changeRequest: 'CHANGE_REQUEST',
        other: 'SC'
    },
    SUPPLIER_GROUPING: {
        appSupport: 'SPR',
        reqNew: 'CONTACT'
    }
};
